import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import {
    ModalProvider,
    ModalControl,
    Link,
    Text,
    InternalGrid,
    SkeletonItem,
    Image,
} from '@paygreen/paygreen-ui';
import { SimpleActionButton } from '../../../components';
import { ImageContainer } from './UploadLogo.styled';
import UploadLogoModal from './UploadLogoModal';

const UploadLogo = ({
    t,
    charityDataLocal,
    charityListData,
    setCharityListData,
    isLoading,
    updateData,
    showLogo,
    showButton,
}) => {
    const { pathname } = useLocation();
    const isCharityPage = pathname === '/user/charity';

    return (
        <SkeletonItem isLoading={isLoading} colorWab="grey10">
            <InternalGrid
                displayType="grid"
                gridTemplateColumns="1fr"
                hasStaticWidth={false}
                justifyItems="center"
            >
                {showLogo && (
                    <ImageContainer hasBorder={true}>
                        <Image shadowSize="none">
                            <img
                                src={charityDataLocal?.picture1}
                                alt="logo preview"
                            />
                        </Image>
                    </ImageContainer>
                )}

                {showButton && (
                    <ModalProvider>
                        <ModalControl hasOnClickControl={true}>
                            {isCharityPage ? (
                                <SimpleActionButton icon="PenIcon">
                                    {t('form.button.edit')}
                                </SimpleActionButton>
                            ) : (
                                <button>
                                    <Link colorTheme="quaternary">
                                        <Text
                                            colorPallet="theme"
                                            colorTheme="quaternary"
                                            textSize="xs"
                                        >
                                            {t('form.button.edit')}
                                        </Text>
                                    </Link>
                                </button>
                            )}
                        </ModalControl>

                        <ModalControl>
                            <UploadLogoModal
                                idAssociation={charityDataLocal?.idAssociation}
                                charityData={
                                    charityListData
                                        ? charityListData[0]
                                        : charityDataLocal
                                }
                                setCharityListData={setCharityListData}
                                updateData={updateData}
                            />
                        </ModalControl>
                    </ModalProvider>
                )}
            </InternalGrid>
        </SkeletonItem>
    );
};

UploadLogo.propTypes = {
    charityDataLocal: PropTypes.object,
    charityListData: PropTypes.array,
    setCharityListData: PropTypes.func,
    isLoading: PropTypes.bool,
    showButton: PropTypes.bool,
    showLogo: PropTypes.bool,
};

UploadLogo.defaultProps = {
    isLoading: false,
    showButton: true,
    showLogo: true,
};

export default withTranslation('common')(UploadLogo);
